import { Modal } from 'foundations-components/transitional/components/Modal';
import FirstStep from '../FirstStep';
import SecondStep from '../SecondStep';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import ThirdStep from '../ThirdStep';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { Paths, StepsMap } from '../Routes';
import { useEffect } from 'react';
import { useSignup } from '../../hooks/useSignup';
import { getIsMobile } from '../../utils/deviceUtils';
import { WizardMobileHeader } from './WizardMobileHeader';
import { WizardMobileFooter } from './WizardMobileFooter';
import { WizardStep, WizardHeaderWithOverview, Wizard as FoundationsWizard } from 'foundations-components/transitional/components/Wizard';
import { MessageUtils } from 'feature-unboxing-common';
import { IframeUtils } from 'feature-unboxing-common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function Wizard() {
  const {
    step
  } = useParams();
  const {
    search
  } = useLocation();
  const history = useHistory();
  const {
    signup
  } = useSignup();
  const isMobile = getIsMobile();
  const stepIndex = StepsMap.indexOf(`/${step}`);
  useEffect(() => {
    if (stepIndex < 0) {
      history.push({
        pathname: StepsMap[0],
        search
      });
    }
  }, [stepIndex, history, search]);
  if (stepIndex < 0) {
    return null;
  }
  const handleNext = () => {
    const nextStepIndex = stepIndex + 1;
    if (nextStepIndex < StepsMap.length) {
      history.push({
        pathname: StepsMap[nextStepIndex],
        search
      });
    }
  };
  const handleDone = () => {
    void signup();
  };
  return /*#__PURE__*/_jsx(Modal, {
    use: "fullscreen",
    children: /*#__PURE__*/_jsxs(FoundationsWizard, {
      defaultHeading: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.wizardHeading"
      }),
      headerComponent: isMobile ? WizardMobileHeader : WizardHeaderWithOverview,
      stickyHeader: false,
      stepIndex: StepsMap.indexOf(`/${step}`),
      onStepIndexChange: event => {
        history.push({
          pathname: StepsMap[event.target.value],
          search
        });
      },
      defaultNextButton: null,
      defaultDoneButton: null,
      onConfirm: () => void signup(),
      onReject: () => {
        if (IframeUtils.isInIframe()) {
          MessageUtils.sendCloseIframeMessage();
        } else {
          history.push({
            pathname: Paths.WIZARD.replace('/:step', StepsMap[0]),
            search
          });
        }
      },
      backable: true,
      cancellable: true,
      footerComponent: isMobile ? WizardMobileFooter : undefined,
      children: [/*#__PURE__*/_jsx(WizardStep, {
        name: I18n.text('app.firstStep.stepName'),
        children: /*#__PURE__*/_jsx(FirstStep, {
          step: step,
          onNext: handleNext
        })
      }), /*#__PURE__*/_jsx(WizardStep, {
        name: I18n.text('app.secondStep.stepName'),
        children: /*#__PURE__*/_jsx(SecondStep, {
          step: step,
          onNext: handleNext
        })
      }), /*#__PURE__*/_jsx(WizardStep, {
        name: I18n.text('app.thirdStep.stepName'),
        children: /*#__PURE__*/_jsx(ThirdStep, {
          step: step,
          onNext: handleDone
        })
      })]
    })
  });
}